module.exports = __webpack_public_path__ + "img/greenprint-white.ebcb6b42.png";